export default __webpack_public_path__ + "static/media/postgresql-small.b1e68333.svg";